import React, { Fragment, useState, useEffect } from 'react'
import { ArrowLeftCircle } from 'iconoir-react';
import { useNavigate, useParams } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import FileItem from '../../components/FileItemComponent/FileItem';
import SkeletonNewsDetail from './../../components/Skeleton/SkeletonNewsDetail';
import moment from 'moment';
import { message } from 'antd';

const TinTucDetail = ({ tintucStore }) => {
    const navigate = useNavigate();
    const { newsId } = useParams();
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                await Promise.all([tintucStore.getById(newsId)]);
            } catch (err) {
                console.log(err);
                if(err.errorCode === "NEWS_NOT_FOUND"){
                    navigate('/utility/general-notifications')
                    message.error('Không tìm thấy thông báo!')
                }
            } finally {
                setLoading(false);
            }
        })();
    }, [])

    let newDetails = toJS(tintucStore.newDetails);

    return (
        <div className='pt-6 px-5'>
            {loading ? (<SkeletonNewsDetail />) : <Fragment>
                <div className='mb-5 flex'>
                    <div className='w-5 h-5 mr-[22px]'>
                        <ArrowLeftCircle className='w-5 h-5 mr-5 mt-1 cursor-pointer' onClick={() => navigate(-1)} />
                    </div>
                    <div className="font-bold text-[28px] leading-[29px]  ">
                        {newDetails?.subject}
                    </div>
                </div>
                <p className='font-[600] mb-2'>
                    Nội dung:
                </p>
                {newDetails?.content ? <div dangerouslySetInnerHTML={{ __html: newDetails?.content }} /> : <i className='text-[#9F9F9F]'>Không có.</i>}

                <p className='font-[600] mb-2 mt-[14px]'>
                    Tài liệu đính kèm:
                </p>
                <p>
                    {newDetails.attachments?.length > 0 ? <Fragment>
                        {newDetails.attachments.map(file => {
                            let file_id = file.file_id;
                            let file_name = file.file_name;
                            let index = file.file_name?.indexOf('.') + 1
                            let file_type = file.file_name?.slice(index);
                            return <FileItem file_id={file_id} file_name={file_name} file_type={file_type} />
                        })}
                    </Fragment> : <i className='text-[#9F9F9F]'>Không có.</i>}
                </p>
                <p className='font-[600] mb-2 mt-[14px]'>
                    Ngày đăng:
                </p>
                <p className='mb-20'>
                    {moment(newDetails?.created_date).format('HH:mm')} - {moment(newDetails?.created_date).format('DD/MM/YYYY')}
                </p>
            </Fragment>
            }
        </div >
    )
}

export default inject("tintucStore")(observer(TinTucDetail));
